import apex_uat from "./apex_uat"
import apex from "./apex"
export default { apex, apex_uat }
